import "%js%/common.js";
import "%blocks%/blocks.js";